const styles = {
  default: {
    display: "inline-block",
    // borderWidth: '1px',
    // borderStyle: 'solid',
  },
}

export default styles
